/*
 * defaultColumn.js maker 191126
 * 시트 생성 시 기본 컬럼 관리
 */

export default {
    requireColumn() {
		let d = [
			{
			  "attr": "pcust_barcode",
			  "code": "C00023",
			  "columnName": "Barcode",
			  "division": "O",
			  "type": "STRING",
			  "columnCode": "C00023",
			  "columnsort": 4
			},
			{
			  "attr": "pcust_name",
			  "code": "C00089",
			  "columnName": "이름",
			  "division": "C",
			  "type": "STRING",
			  "columnCode": "C00089",
			  "columnsort": 5
			},
			{
			  "attr": "brth_date",
			  "code": "C00025",
			  "columnName": "Birth",
			  "division": "C",
			  "type": "DATE",
			  "columnCode": "C00025",
			  "columnsort": 6
			},
			{
			  "attr": "gen",
			  "code": "C00024",
			  "columnName": "성별",
			  "division": "C",
			  "type": "LIST",
			  "columnCode": "C00024",
			  "columnsort": 7
			},
			{
			  "attr": "phone",
			  "code": "C00335",
			  "columnName": "phone",
			  "division": "C",
			  "type": "STRING",
			  "columnCode": "C00335",
			  "columnsort": 14
			},
			{
			  "attr": "reg_date",
			  "code": "C00336",
			  "columnName": "검체 의뢰일자",
			  "division": "C",
			  "type": "STRING",
			  "columnCode": "C00336",
			  "columnsort": 15
			}
		]
		return d;
	},
}



// WEBPACK FOOTER //
// ./src/views/Common/mediage/column.js